import React, { useState, useEffect, useRef } from "react";
import "./CourseEdit.scss";
import EditableChapter from "./EditableChapter";
import Dependent from "../../Dependent";
import axiosInstance from "../../../../../../../axios";
import { isNullOrEmpty } from "../../../../../../../_helpers";
import { debounce } from "lodash";
import { Loading } from "../../../../../../Other/Loading";
import EditSubmit from "./EditSubmit";
import CourseImageUpload from "../../../CourseImageUpload";
import CourseVideoUpload from "../../../CourseVideoUpload";
import OverlayContainer from "../../../../../../Overlay/OverlayContainer";
// import CoursePreview from "../../../../../../Courses/CoursePreview/CoursePreview";
import { getS3URL } from "../../../../../../../_helpers";
import { CourseBuilderStaticData } from "../../../../../../../_constants/staticData";
import Quiz from "../Quiz";
import WebinarScheduler from "../WebinarSchedular";
import TextEditor from "../TextEditor";
import CreateBundle from "../../../CreateBundle";
import CoursePreview from "../../../../../../CoursePreview/CoursePreview";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const { REACT_APP_PAYMENT_API_BASEURL } = process.env;

const CourseEdit = (props) => {
  const [editImage, setEditImage] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isCurrentFileUpload, setIsCurrentFileUpload] = useState(false);
  const editImageRef = useRef();
  const param = useParams();
  const [formValues, setFormValues] = useState({
    id: "",
    courseType: "",
    courseName: "",
    category: "",
    subCategory: "",
    courseOneLiner: "",
    IsAdult: "0",
    goals: [{ name: "" }, { name: "" }],
    preRequisites: [{ name: "" }],
    description: null,
    courseOutDescription: null,
    status: "",
    faqs: [{ question: "", answer: "" }],
    syllabus: [{ name: "" }],
    level: "",
    language: "",
    duration: "",
    imageFiles: [],
    videoFiles: [],
    courses: [],
    courseSections: [
      {
        sectionName: "",
        sectionDescription: null,
        files: [],
        videoLink: "",
      },
    ],
    isFree: true,
    currency: "",
    enrollmentFee: 0,
    promotionalOffer: false,
    promotionalCode: "",
    discountPercent: "",
  });
  const courseId = props?.location?.state?.courseId;
  const bundle = props?.location?.state?.bundle;

  const fetchAll = () => {
    bundle
      ? axiosInstance
          .get(`${REACT_APP_PAYMENT_API_BASEURL}/v2/bundles/` + courseId)
          .then((res) => {
            setFormValues({
              id: res.data.data.id,
              courseName: res.data.data.name,
              description: res.data.data.description,
              duration: res.data.data.duration,
              enrollmentFee: res.data.data.price,
              imageFiles: [res.data.data.imageLink],
              courses: res.data.data?.courses,
              goals: res.data.data?.goals[0],
              faqs: res.data.data?.faqs[0],
              preRequisites: res.data.data?.preRequisites[0],
              level: res.data.data?.level,
              language: res.data.data?.language,
              courseOneLiner: res.data.data?.bundleOneLiner,
            });
            setIsFetching(false);
          })
          .catch((res) => {
            setIsFetching(false);
          })
      : axiosInstance
          .get("course/" + (courseId || param.id))
          .then((res) => {
            setFormValues(mapApiResponseToState(res?.data?.data?.recordset[0]));
            setIsFetching(false);
          })
          .catch((res) => {
            setIsFetching(false);
          });
  };
  const isCurrentFileUploadStatus = (value) => {
    setIsCurrentFileUpload(value);
  };

  useEffect(() => {
    fetchAll();
  }, []);

  const mapApiResponseToState = (courseResponseData) => {
    return {
      id: courseResponseData.ID,
      courseType: courseResponseData.courseType,
      courseName: courseResponseData.CourseName,
      category: courseResponseData.Category,
      subCategory: courseResponseData.SubCategory,
      courseOneLiner: courseResponseData.courseOneLiner,
      IsAdult: courseResponseData.IsAdult,
      courseOutDescription: courseResponseData.courseOutDescription,
      goals:
        courseResponseData.goals.length === 0
          ? [{ name: "" }, { name: "" }]
          : courseResponseData.goals,
      preRequisites:
        courseResponseData.preRequisites.length === 0
          ? [{ name: "" }]
          : courseResponseData.preRequisites,
      description: courseResponseData.Description
        ? courseResponseData.Description
        : courseResponseData.Description,
      faqs:
        courseResponseData.faqs.length === 0
          ? [{ question: "", answer: "" }]
          : courseResponseData.faqs,

      syllabus:
        courseResponseData.syllabus.length === 0
          ? [{ name: "" }]
          : courseResponseData.syllabus,
      status: courseResponseData.Status === 1 ? 2 : courseResponseData.Status,
      level: courseResponseData.Level,
      language: courseResponseData.Language,
      duration: courseResponseData.Duration,
      imageFiles: courseResponseData.imageFiles,
      videoFiles: courseResponseData.videoFiles,
      courseSections: courseResponseData?.courseSections?.map((section) => ({
        ...section,
        name: section.sectionName,
        description: section.sectionDescription
          ? section.sectionDescription
          : section.sectionDescription,
        id: section.id,
        isEdit: true,
      })),
      isFree: courseResponseData.IsFree,
      currency: courseResponseData.Currency,
      enrollmentFee: courseResponseData.EnrollmentFee,
      promotionalOffer: courseResponseData.PromotionalOffer,
      promotionalCode: courseResponseData.PromotionalCode,
      discountPercent: courseResponseData.DiscountPercent,
    };
  };

  const [showCoursePreview, setShowCoursePreview] = useState(false);
  const [quizCreation, setQuizCreation] = useState({
    name: "",
    guidelines: "",
    id: courseId,
    questions: [
      {
        question: null,
        type: null,
        answers: [{ answer: "", isRight: false }],
      },
    ],
  });

  const [showMore, setShowMore] = useState(false);
  const [showMoreHighlight, setShowMoreHighlight] = useState(false);
  const [showMoreSyllabus, setShowMoreSyllabus] = useState(false);
  const [showMoreFaqs, setShowMoreFaqs] = useState(false);
  const [updateQuizResponse, setUpdateQuizResponse] = useState();

  const [isFetching, setIsFetching] = useState(true);

  const [errors, setErrors] = useState({
    goals: [],
    preRequisites: [],
    faqs: [],
    syllabus: [],
    courseSections: [],
  });

  const numberOfItems = showMore ? formValues?.goals.length : 2;
  const numberOfHighlight = showMoreHighlight
    ? formValues?.preRequisites?.length
    : 2;
  const numberOfSyllabus = showMoreSyllabus ? formValues?.syllabus?.length : 2;
  const numberOfFaqs = showMoreFaqs ? formValues?.faqs?.length : 2;

  const handleExpand = () => {
    setShowMore(!showMore);
  };

  const handleHighlightExpand = () => {
    setShowMoreHighlight(!showMoreHighlight);
  };

  const handleSyllabusExpand = () => {
    setShowMoreSyllabus(!showMoreSyllabus);
  };

  const handleFaqsExpand = () => {
    setShowMoreFaqs(!showMoreFaqs);
  };

  const handleInputChange = (index, name, value, accessor = null) => {
    let clonedValues = [...formValues[name]];
    setFormValues({
      ...formValues,
      [name]: bindFormValues(index, value, clonedValues, accessor),
    });
  };

  const bindFormValues = (index, value, items, accessor = null) => {
    accessor ? (items[index][accessor] = value) : (items[index] = value);
    return items;
  };

  const canAddMoreFields = (
    formData,
    errors,
    property,
    max,
    isNested = null
  ) => {
    let isValid = isNested
      ? formData[property].every((item) =>
          Object.values(item).every((value) => isNullOrEmpty(value))
        )
      : formData[property].every((item) => isNullOrEmpty(item));
    return (
      isValid &&
      formData[property].length < max &&
      errors[property].every((item) => item.valid)
    );
  };

  const addFormFields = (
    event,
    property,
    max,
    prevState,
    errors,
    value = "",
    accessor = null
  ) => {
    event.preventDefault();
    if (canAddMoreFields(prevState, errors, property, max, accessor)) {
      setFormValues({
        ...formValues,
        [property]: [...formValues[property], value],
      });
    }
  };

  const isDuplicate = (input, items) =>
    items.some(
      (item) => item.name.toLowerCase() === input.trim().toLowerCase()
    );

  const validateDuplicateText = (value, index, property, items) => {
    if (isNullOrEmpty(value) && isDuplicate(value, items)) {
      setErrors({
        ...errors,
        [property]:
          errors[property].filter((item) => item.id === index).length > 0
            ? errors[property]
            : [...errors[property], { id: index, vaild: false }],
      });
    } else {
      setErrors({
        ...errors,
        [property]: [...errors[property].filter((item) => item.id !== index)],
      });
    }
  };

  const removeFormFieldError = (property, index) => {
    if (
      errors[property].length > 0 &&
      errors[property].some((error) => error.id === index)
    ) {
      const formErrors = errors[property].filter((error) => error.id !== index);
      setErrors({ ...errors, [property]: formErrors });
    }
  };

  const removeFormFields = (event, index, property) => {
    event.preventDefault();
    let newFormValues = [...formValues[property]];
    newFormValues.splice(index, 1);
    removeFormFieldError(property, index);
    setFormValues({ ...formValues, [property]: newFormValues });
  };

  const [numError, setNumError] = useState("");
  const [quizResponse, setQuizResponse] = useState(false);
  const [quizStatus, setQuizStatus] = useState(false);
  const [popup, setPopUp] = useState(false);
  const [success, setSuccess] = useState(false);
  const [quizPop, setQuizPop] = useState(false);
  const [quizValidateMsg, setQuizValidateMsg] = useState(false);

  const [warning, setWarning] = useState(false);
  const [stateShow, setStateShow] = useState({
    Title: false,
    video: false,
    meetingDescription: false,
    invites: false,
    Highlights: false,
    Requirement: false,
    description: false,
    courseOutDescription: false,
    Faqs: false,
    courseOneLiner: false,
    category: true,
    Syallbus: false,
    level: true,
    language: false,
    duration: false,
    price: false,
    saveall: false,
    submit: false,
    cancel: false,
    quiz: false,
    WebinarScheduler: false,
    selectedCourse: false,
  });
  const [editResponse, setEditResponse] = useState(null);

  const handle = ({ name, value }) => {
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleEditorStateChange = (name, accessor = null, index = null) =>
    debounce((editorState) => {
      setFormValues((state) => ({
        ...state,
        [name]: bindEditorState(
          accessor,
          index,
          editorState,
          !bundle && [...state.courseSections]
        ),
      }));
    }, 500);

  const bindEditorState = (accessor, index, editorState, items) => {
    if (accessor) {
      items[index][accessor] = editorState;
      return items;
    } else {
      return editorState;
    }
  };

  const EditSubmitHandler = () => {
    setStateShow({ ...stateShow, saveall: true });
    setWarning(!warning);
  };

  const closeHandler = (value) => {
    setStateShow({ ...stateShow, saveall: value });
    setWarning(value);
  };

  const convertDesciptionToHtml = (sections, courseId) => {
    let mappedSections = [];
    for (var section of sections) {
      let mappedfiles = section.files;
      mappedSections.push({
        name: section.name,
        videoLink: section.videoLink,
        courseId: courseId,
        id: section.id,
        description: section.description
          ? section.description
          : section.description,
        files: mappedfiles,
      });
    }
    return mappedSections;
  };

  const SubmitHandler = async () => {
    setEditResponse("");
    setStateShow({ ...stateShow, saveall: true });
    setPopUp(true);
    axiosInstance
      .put(
        "course/" + formValues.id,
        formValues.courseType !== "liveCourse"
          ? JSON.stringify({
              ...formValues,
              description: formValues.description
                ? formValues.description
                : formValues.description,
              courseName: formValues.courseName,
              courseSections: formValues.courseSections,
              preRequisites:
                formValues.preRequisites[0].name === ""
                  ? []
                  : formValues.preRequisites,
            })
          : JSON.stringify({
              id: formValues.id,
              courseType: formValues.courseType,
              description: formValues.description
                ? formValues.description
                : formValues.description,
              courseName: formValues.courseName,
              category: formValues.category,
              subCategory: formValues.subCategory,
              imageFiles: formValues.imageFiles,
              isFree: formValues.isFree,
              currency: formValues.currency,
              enrollmentFee: formValues.enrollmentFee,
              level: formValues.level,
              status: 2,
            }),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setEditResponse(res?.data);
        setPopUp(false);
        setSuccess(true);
      })
      .catch((res) => console.log(res));
  };

  const SubmitHandlerBundle = async () => {
    setEditResponse("");
    setStateShow({ ...stateShow, saveall: true });
    setPopUp(true);
    axiosInstance
      .put(
        `${REACT_APP_PAYMENT_API_BASEURL}/v2/bundles/` + formValues.id,
        JSON.stringify({
          name: formValues.courseName,
          description: formValues.description,
          duration: formValues.duration,
          price: formValues.enrollmentFee,
          courses: formValues?.courses?.map((ele) => ele.ID),
          imageLink: formValues.imageFiles[0],
          goals: formValues.goals,
          faqs: formValues.faqs,
          preRequisites: formValues.preRequisites,
          level: formValues.level,
          language: formValues.language,
          bundleOneLiner: formValues.courseOneLiner,
        }),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setEditResponse(res?.data);
        setPopUp(false);
        setSuccess(true);
      })
      .catch((res) => console.log(res));
  };

  const handledependent = ({ name, value }) => {
    setFormValues((state) => ({
      ...state,
      [name]: value,
    }));
  };

  const courseImageFile = (content) => {
    if (content.length > 0) readImageFile(content);
  };
  const readImageFile = (file) => {
    let temp = [];
    file.forEach((element, index) => {
      const reader = new FileReader();
      reader.onload = function (e) {
        const Testing = element.name;
        const extension = Testing.split(".").pop();
        const Filename = Testing.split(".").slice(0, -1).join(".");
        temp.push({
          isUpdated: true,
          fileName: Filename,
          base64: reader.result,
          fileExt: extension,
          fileSize: element.size,
        });
        setFormValues({ ...formValues, imageFiles: temp });
      };
      reader.readAsDataURL(element);
    });
  };

  const handleEdit = () => {
    setEditImage((state) => !state);
  };

  const renderCourseImage = (files) => {
    return (
      <div>
        <img
          alt="test"
          src={
            files && files.length > 0
              ? getS3URL(files[0].fileName)
              : getS3URL("edusityUI/icons/icon-brokenImg.svg")
          }
          className="header-Mycourse-detailsSection-img"
        />
      </div>
    );
  };

  const courseVideoFile = (content) => {
    if (content.length > 0) {
      setFormValues({
        ...formValues,
        videoFiles: [...formValues.videoFiles, content],
      });
    } else {
      setFormValues({ ...formValues, videoFiles: [] });
    }
  };

  const handleCoursePreview = (event) => {
    event.preventDefault();
    setShowCoursePreview(!showCoursePreview);
  };
  const courseFile =
    (sectionIndex, courseDetailId, courseId, formValues) => (content) => {
      if (content != null && typeof content == "object" && content.length > 0) {
        const previousCourseSection = [...formValues.courseSections];
        previousCourseSection[sectionIndex].files = [
          ...previousCourseSection[sectionIndex].files,
          ...content.map((file) => ({
            ...file,
            courseDetailId: courseDetailId,
            courseID: courseId,
          })),
        ];
        setFormValues({
          ...formValues,
          courseSections: previousCourseSection,
        });
      }
    };

  const quizCentalizeData = (values) => {
    return {
      status: 1,
      name: values.name,
      guidelines: values.guidelines,
      id: values.id,
      questions: values.questions.map((items) => ({
        id: items.id,
        question: items.question,
        type: items.type,
        answers: items.options.map((elements) => ({
          answer: elements.answer,
          id: elements.id,

          isRight: elements.isRight === 0 ? false : true,
        })),
      })),
    };
  };

  const handleraccordion = () => {
    setIsActive(!isActive);
  };

  useEffect(() => {
    axiosInstance
      .get(`/quiz/${courseId}`)
      .then((res) => {
        if (res.data.data.length > 0) {
          setQuizCreation(quizCentalizeData(res.data.data[0]));
          setQuizStatus(true);
        } else setQuizCreation(quizCreation);
      })
      .catch((res) => console.log(res));
  }, [courseId]);

  const quizSubmitHandler = () => {
    setQuizResponse(true);
    quizStatus
      ? axiosInstance
          .post(`/quiz/${quizCreation.id}`, quizCreation)
          .then((res) => {
            setUpdateQuizResponse(res.data.message);
            setQuizResponse(false);
            setQuizPop(true);
          })
          .catch((res) => console.log(res))
      : axiosInstance
          .post(`/quiz`, quizCreation)
          .then((res) => {
            setUpdateQuizResponse(res.data.message);
            setQuizResponse(false);
            setQuizPop(true);
          })
          .catch((res) => console.log(res));
  };

  const checkIfNumber = (event) => {
    const regex = new RegExp(
      /(^\d*$)|(Backspace|Tab|Delete|ArrowLeft|ArrowRight)/
    );

    if (!event.key.match(regex)) {
      setNumError("*Please enter a number ");
    } else {
      setNumError("");
    }

    return !event.key.match(regex) && event.preventDefault();
  };
  return (
    <>
      {isFetching ? (
        <div className="edit-loading">
          <Loading />
        </div>
      ) : (
        formValues && (
          <>
            <section className="container-wrapper">
              {!editImage ? (
                <>
                  {bundle ? (
                    <div className="header-Mycourse-detailsSection">
                      <img
                        src={
                          formValues?.imageFiles
                            ? getS3URL(formValues.imageFiles[0])
                            : getS3URL("edusityUI/icons/icon-brokenImg.svg")
                        }
                        className="header-Mycourse-detailsSection-img"
                      />
                      <img
                        src="https://cdn.edusity.com/icons/icon-photo-camera.svg"
                        className="header-Mycourse-detailsSection-play"
                        alt="play-button"
                        onClick={handleEdit}
                      />
                    </div>
                  ) : (
                    <div className="header-Mycourse-detailsSection">
                      {renderCourseImage(formValues.imageFiles)}
                      <img
                        src="https://cdn.edusity.com/icons/icon-photo-camera.svg"
                        className="header-Mycourse-detailsSection-play"
                        alt="play-button"
                        onClick={handleEdit}
                      />
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="courseimageuploadcancel">
                    <i class="icon check" onClick={handleEdit}></i>
                  </div>
                  <div className="course-imageEdit">
                    <CourseImageUpload
                      courseImageFileLimit={1}
                      courseImageFile={courseImageFile}
                      editImageRef={editImageRef}
                      isCurrentFileUploadStatus={isCurrentFileUploadStatus}
                      isCurrentFileUpload={isCurrentFileUpload}
                      history={props.history}
                      uploadedFileID={
                        formValues.imageFiles.length > 0
                          ? formValues.imageFiles[0].id
                          : 0
                      }
                    />
                  </div>
                </>
              )}

              <div className="Mycourse-detailsSection-btn">
                <button className="cancelChange" onClick={EditSubmitHandler}>
                  Cancel All Changes
                </button>
                <button
                  className="saveChange"
                  onClick={bundle ? SubmitHandlerBundle : SubmitHandler}
                >
                  Save All Change
                </button>
              </div>

              <div className="main-myCourseDetails">
                <div className="editContainer">
                  <button
                    className="courseEdit-content"
                    onClick={() =>
                      setStateShow((stateShow) => ({
                        ...stateShow,
                        Title: !stateShow.Title,
                      }))
                    }
                  >
                    {stateShow.Title ? "Update -" : " Edit +"}
                  </button>

                  <div className="edit-section-title">Title</div>
                  <ul>
                    {stateShow.Title === false ? (
                      <li>{formValues.courseName}</li>
                    ) : (
                      <></>
                    )}
                  </ul>
                  {stateShow.Title === true && (
                    <div className="courseGetContent-subClass">
                      <input
                        type="text"
                        name="courseName"
                        value={formValues.courseName}
                        onChange={({ target }) => handle(target)}
                      />
                    </div>
                  )}
                </div>
                {/* <div className="editContainer">
                <div className="edit-section-title">Meeting Description</div>
                <button
                  className="courseEdit-content"
                  onClick={() =>
                    setStateShow((stateShow) => ({
                      ...stateShow,
                      meetingDescription: !stateShow.meetingDescription,
                    }))
                  }
                >
                  {stateShow.meetingDescription ? "Update -" : " Edit +"}
                </button>
                {stateShow.meetingDescription && (
                  <div className="form-wrap-inputCourse">
                    <textarea
                      name="meetDescription"
                      rows="4"
                      cols="50"
                      placeholder="Short description for this meet"
                      className="custom-input"
                      value={formValues.meetDescription}
                      onChange={({ target }) => handleInputChange(target)}
                    />
                  </div>
                )}
              </div>
              <div className="editContainer">
                <div className="edit-section-title">Invites</div>
                <button
                  className="courseEdit-content"
                  onClick={() =>
                    setStateShow((stateShow) => ({
                      ...stateShow,
                      invites: !stateShow.invites,
                    }))
                  }
                >
                  {stateShow.invites ? "Update -" : " Edit +"}
                </button>
                {stateShow.invites && (
                  <div className="form-wrap-inputCourse">
                    <textarea
                      name="invite"
                      rows="4"
                      cols="50"
                      placeholder="Please type or paste emails seperated bu commas i.e adam@something.com, steve@something.com,ariah@something.com"
                      className="custom-input"
                      value={formValues.invite}
                      onChange={({ target }) => handleInputChange(target)}
                    />
                  </div>
                )}
              </div> */}

                {formValues.courseType !== "liveCourse" && (
                  <>
                    {!bundle && (
                      <div className="editContainer">
                        <button
                          className="courseEdit-content"
                          onClick={() =>
                            setStateShow((stateShow) => ({
                              ...stateShow,
                              video: !stateShow.video,
                            }))
                          }
                        >
                          {stateShow.video ? "Update -" : " Edit +"}
                        </button>

                        <div className="edit-section-title">Course Trailer</div>
                        <ul>
                          {stateShow.video === false ? (
                            <>
                              {formValues?.videoFiles[0]?.fileName && (
                                <li>
                                  <img
                                    src="https://cdn.edusity.com/edusityUI/icons/icon_video_play.svg"
                                    onClick={handleCoursePreview}
                                    alt="play"
                                  />
                                </li>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                          {formValues?.videoFiles?.length < 1 && (
                            <span style={{ color: "#FF0000", fontWeight: 500 }}>
                              Please upload Course Trailer
                            </span>
                          )}
                        </ul>
                        {stateShow.video === true && (
                          <div className="courseGetContent-subClass">
                            <CourseVideoUpload
                              courseVideoFileLimit={1}
                              courseVideoFile={courseVideoFile}
                              history={props.history}
                              isCurrentFileUploadStatus={
                                isCurrentFileUploadStatus
                              }
                              isCurrentFileUpload={isCurrentFileUpload}
                              uploadedFileID={
                                formValues.videoFiles.length > 0
                                  ? formValues.videoFiles[0].id
                                  : 0
                              }
                            />
                          </div>
                        )}
                      </div>
                    )}

                    <div className="editContainer li-list-style-square">
                      <button
                        className="courseEdit-content"
                        onClick={() =>
                          setStateShow((stateShow) => ({
                            ...stateShow,
                            Highlights: !stateShow.Highlights,
                          }))
                        }
                      >
                        {stateShow.Highlights ? "Update -" : "Edit +"}
                      </button>

                      <div className="edit-section-title">Course Goals</div>
                      <ul>
                        {stateShow && stateShow.Highlights === false && (
                          <>
                            {formValues &&
                              formValues.goals[0]?.name !== "" &&
                              formValues.goals.length > 0 &&
                              formValues.goals
                                .slice(0, numberOfItems)
                                .map((items, index) => (
                                  <li key={index}>{items.name}</li>
                                ))}
                          </>
                        )}
                      </ul>
                      {stateShow.Highlights === false && (
                        <>
                          {formValues.goals[0]?.name === "" && (
                            <span style={{ color: "#FF0000", fontWeight: 500 }}>
                              Please fill out Course goals
                            </span>
                          )}
                        </>
                      )}

                      {stateShow && stateShow.Highlights === true && (
                        <div className="define-add-input">
                          {formValues &&
                            formValues.goals &&
                            formValues.goals.map((item, index) => (
                              <>
                                <div className="form-inline" key={index}>
                                  <input
                                    type="text"
                                    name="goals"
                                    placeholder="Define goals"
                                    value={item.name}
                                    className={
                                      errors.goals.filter(
                                        (item) => item.id === index
                                      ).length > 0
                                        ? "error"
                                        : ""
                                    }
                                    onChange={({ target }) =>
                                      handleInputChange(
                                        index,
                                        target.name,
                                        target.value,
                                        "name"
                                      )
                                    }
                                    onBlur={({ target }) =>
                                      validateDuplicateText(
                                        target.value,
                                        index,
                                        target.name,
                                        [
                                          ...formValues.goals.filter(
                                            (_, i) => i !== index
                                          ),
                                        ]
                                      )
                                    }
                                    disabled={
                                      errors.goals.length > 0 &&
                                      errors.goals.some(
                                        (item) => item.id !== index
                                      )
                                    }
                                  />
                                  <div className="input-validations">
                                    {errors.goals.some(
                                      (item) => item.id === index
                                    ) && (
                                      <span className="input-error">
                                        Duplicate text
                                      </span>
                                    )}
                                  </div>

                                  {index > 1 && (
                                    <img
                                      name="goals"
                                      role="button"
                                      className="align-textRemove"
                                      href="javascript(void);"
                                      onClick={(event) =>
                                        removeFormFields(
                                          event,
                                          index,
                                          event.target.name
                                        )
                                      }
                                      src="https://cdn.edusity.com/icons/icon-trash.svg"
                                      alt=""
                                    />
                                  )}
                                </div>
                              </>
                            ))}
                          <div className="define-add-text">
                            <a
                              href="javascript(void);"
                              onClick={(event) =>
                                addFormFields(
                                  event,
                                  "goals",
                                  10,
                                  {
                                    ...formValues,
                                    goals: formValues.goals.map(({ name }) => ({
                                      name,
                                    })),
                                  },
                                  errors,
                                  { name: "" },
                                  true
                                )
                              }
                            >
                              + Add More fields
                            </a>
                          </div>
                        </div>
                      )}

                      {stateShow && stateShow.Highlights === false && (
                        <>
                          {formValues.goals.length > 2 && (
                            <button
                              className="exapnd-courseHighLights"
                              onClick={handleExpand}
                            >
                              {showMore ? "- Read less" : "+ Read more"}
                            </button>
                          )}
                        </>
                      )}
                    </div>

                    <div className="editContainer">
                      <button
                        className="courseEdit-content"
                        onClick={() =>
                          setStateShow((stateShow) => ({
                            ...stateShow,
                            courseOneLiner: !stateShow.courseOneLiner,
                          }))
                        }
                      >
                        {stateShow.courseOneLiner ? "Update -" : "Edit +"}
                      </button>

                      <div className="edit-section-title">
                        Course One Linear (optional)
                        <ul>
                          {stateShow.courseOneLiner === false ? (
                            <li>{formValues.courseOneLiner}</li>
                          ) : (
                            <></>
                          )}
                        </ul>
                        {stateShow.courseOneLiner === true && (
                          <div className="courseGetContent-subClass">
                            <input
                              type="text"
                              name="courseOneLiner"
                              value={formValues.courseOneLiner}
                              onChange={({ target }) => handle(target)}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="editContainer">
                      <button
                        className="courseEdit-content"
                        onClick={() =>
                          setStateShow((stateShow) => ({
                            ...stateShow,
                            Requirement: !stateShow.Requirement,
                          }))
                        }
                      >
                        {stateShow.Requirement ? "Update -" : "Edit +"}
                      </button>

                      <div className="edit-section-title">
                        Course preRequisites (optional)
                      </div>
                      <ul>
                        {stateShow && stateShow.Requirement === false && (
                          <>
                            {formValues.preRequisites &&
                              formValues.preRequisites[0]?.name !== "" &&
                              formValues.preRequisites
                                .slice(0, numberOfHighlight)
                                .map((items, index) => (
                                  <li key={index}>{items.name}</li>
                                ))}
                            {/* {formValues.preRequisites[0].name === "" && (
                            <span style={{ color: "#FF0000", fontWeight: 500 }}>
                              Please fill out course prerequisites
                            </span>
                          )} */}
                          </>
                        )}
                        {formValues.preRequisites.length > 2 && (
                          <button
                            className="exapnd-courseHighLights"
                            onClick={handleHighlightExpand}
                          >
                            {showMoreHighlight ? "- Read less" : "+ Read more"}
                          </button>
                        )}
                      </ul>

                      {stateShow && stateShow.Requirement === true && (
                        <div className="define-add-input">
                          {formValues &&
                            formValues.preRequisites.map((item, index) => (
                              <div className="form-inline" key={index}>
                                <input
                                  type="text"
                                  className={
                                    errors.preRequisites.filter(
                                      (item) => item.id === index
                                    ).length > 0
                                      ? "error"
                                      : ""
                                  }
                                  name="preRequisites"
                                  placeholder="Pre-requisites or qualification for this Course"
                                  value={item.name}
                                  maxLength={120}
                                  onChange={({ target }) =>
                                    handleInputChange(
                                      index,
                                      target.name,
                                      target.value,
                                      "name"
                                    )
                                  }
                                  onBlur={({ target }) =>
                                    validateDuplicateText(
                                      target.value,
                                      index,
                                      target.name,
                                      [
                                        ...formValues.preRequisites.filter(
                                          (_, i) => i !== index
                                        ),
                                      ]
                                    )
                                  }
                                  disabled={
                                    errors.preRequisites.length > 0 &&
                                    errors.preRequisites.some(
                                      (item) => item.id !== index
                                    )
                                  }
                                />
                                <span>
                                  Character remaining {120 - item.name.length}{" "}
                                </span>

                                {index > 0 && (
                                  <img
                                    href="javascript(void);"
                                    name="preRequisites"
                                    className="align-textRemove"
                                    onClick={(event) =>
                                      removeFormFields(
                                        event,
                                        index,
                                        event.target.name
                                      )
                                    }
                                    src="https://cdn.edusity.com/icons/icon-trash.svg"
                                    alt=""
                                  />
                                )}
                              </div>
                            ))}
                          <div className="define-add-text">
                            <a
                              href="javascript(void);"
                              onClick={(event) =>
                                addFormFields(
                                  event,
                                  "preRequisites",
                                  10,
                                  {
                                    ...formValues,
                                    preRequisites: formValues.preRequisites.map(
                                      ({ name }) => ({
                                        name,
                                      })
                                    ),
                                  },
                                  errors,
                                  { name: "" },
                                  true
                                )
                              }
                            >
                              + Add More fields
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}

                {!bundle && (
                  <div className="editContainer">
                    <button
                      className="courseEdit-content"
                      onClick={() =>
                        setStateShow((stateShow) => ({
                          ...stateShow,
                          courseOutDescription: !stateShow.courseOutDescription,
                        }))
                      }
                    >
                      {stateShow.courseOutDescription ? "Update -" : "Edit +"}
                    </button>

                    <div className="edit-section-title">
                      course Out Description
                    </div>
                    <ul>
                      {stateShow.courseOutDescription === false &&
                        formValues.courseOutDescription !== "" && (
                          <li>
                            {formValues.courseOutDescription && (
                              <div
                                className="rich-text"
                                dangerouslySetInnerHTML={{
                                  __html: formValues.courseOutDescription,
                                }}
                              ></div>
                            )}
                          </li>
                        )}
                      {stateShow.courseOutDescription === false && (
                        <>
                          {formValues.courseOutDescription === "" && (
                            <span style={{ color: "#FF0000", fontWeight: 500 }}>
                              Please fill out course courseOutDescription
                            </span>
                          )}
                        </>
                      )}
                    </ul>

                    {stateShow.courseOutDescription === true && (
                      <>
                        <TextEditor
                          formState={formValues.courseOutDescription}
                          history={props.history}
                          handleEditorStateChange={handleEditorStateChange(
                            "courseOutDescription"
                          )}
                        />
                      </>
                    )}
                  </div>
                )}
                <div className="editContainer">
                  <button
                    className="courseEdit-content"
                    onClick={() =>
                      setStateShow((stateShow) => ({
                        ...stateShow,
                        description: !stateShow.description,
                      }))
                    }
                  >
                    {stateShow.description ? "Update -" : "Edit +"}
                  </button>

                  <div className="edit-section-title">Course Description</div>
                  <ul>
                    {stateShow.description === false &&
                      formValues.description !== "" && (
                        <li>
                          {formValues.description && (
                            <div
                              className="rich-text"
                              dangerouslySetInnerHTML={{
                                __html: formValues.description,
                              }}
                            ></div>
                          )}
                        </li>
                      )}
                    {stateShow.description === false && (
                      <>
                        {formValues.description === "" && (
                          <span style={{ color: "#FF0000", fontWeight: 500 }}>
                            Please fill out course description
                          </span>
                        )}
                      </>
                    )}
                  </ul>

                  {stateShow.description === true && (
                    <>
                      <TextEditor
                        formState={formValues.description}
                        history={props.history}
                        handleEditorStateChange={handleEditorStateChange(
                          "description"
                        )}
                      />
                    </>
                  )}
                </div>

                {formValues.courseType !== "liveCourse" && (
                  <>
                    <div className="editContainer li-list-style-alpha">
                      <button
                        className="courseEdit-content"
                        onClick={() =>
                          setStateShow((stateShow) => ({
                            ...stateShow,
                            Faqs: !stateShow.Faqs,
                          }))
                        }
                      >
                        {stateShow.Faqs ? "Update -" : "Edit +"}
                      </button>

                      <div className="edit-section-title">Course Faqs</div>
                      <ul className="course-FaqsUL">
                        {stateShow.Faqs === false && (
                          <>
                            {formValues.faqs &&
                              formValues.faqs[0]?.question !== "" &&
                              formValues.faqs
                                .slice(0, numberOfFaqs)
                                .map((faqs, index) => (
                                  <div key={index}>
                                    <li>Question: {faqs.question}</li>
                                    <li>Answer: {faqs.answer}</li>
                                  </div>
                                ))}
                          </>
                        )}
                        {formValues?.faqs?.length > 2 && (
                          <button
                            className="exapnd-courseHighLights"
                            onClick={handleFaqsExpand}
                          >
                            {showMoreFaqs ? "- Read less" : "+ Read more"}
                          </button>
                        )}
                      </ul>
                      {stateShow.Faqs === false && (
                        <>
                          {formValues.faqs[0]?.question === "" && (
                            <span style={{ color: "#FF0000", fontWeight: 500 }}>
                              Please fill out course Faqs
                            </span>
                          )}
                        </>
                      )}
                      {stateShow.Faqs === true && (
                        <div className="define-add-input">
                          {formValues.faqs.map((element, index) => (
                            <div className="form-inline" key={index}>
                              <label htmlFor="question">
                                Question {index + 1}
                              </label>
                              <input
                                type="text"
                                name="question"
                                placeholder={`FAQ's question ${index + 1}`}
                                value={element.question}
                                onChange={({ target }) =>
                                  handleInputChange(
                                    index,
                                    "faqs",
                                    target.value,
                                    target.name
                                  )
                                }
                              />
                              {/* <span>
                          Character remaining {120 - element.question.length}{" "}
                        </span> */}
                              <label htmlFor="answer">Answer</label>
                              <input
                                type="text"
                                name="answer"
                                placeholder={`FAQ's answer ${index + 1}`}
                                value={element.answer}
                                onChange={({ target }) =>
                                  handleInputChange(
                                    index,
                                    "faqs",
                                    target.value,
                                    target.name
                                  )
                                }
                              />
                              {/* <span>
                          Character remaining {120 - element.answer.length}
                        </span> */}

                              {index > 0 ? (
                                <img
                                  name="faqs"
                                  href="javascript(void);"
                                  className="align-textRemove faq"
                                  onClick={(event) =>
                                    removeFormFields(
                                      event,
                                      index,
                                      event.target.name
                                    )
                                  }
                                  src="https://cdn.edusity.com/icons/icon-trash.svg"
                                  alt=""
                                />
                              ) : null}
                            </div>
                          ))}
                          <div className="define-add-text">
                            <a
                              href="javascript(void);"
                              onClick={(event) =>
                                addFormFields(
                                  event,
                                  "faqs",
                                  10,
                                  {
                                    ...formValues,
                                    faqs: formValues.faqs.map(
                                      ({ question, answer }) => ({
                                        question,
                                        answer,
                                      })
                                    ),
                                  },
                                  errors,
                                  {
                                    question: "",
                                    answer: "",
                                  },
                                  true
                                )
                              }
                            >
                              + Add More fields
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                    {!bundle && (
                      <div className="editContainer">
                        <button
                          className="courseEdit-content"
                          onClick={() =>
                            setStateShow((stateShow) => ({
                              ...stateShow,
                              Syallbus: !stateShow.Syallbus,
                            }))
                          }
                        >
                          {stateShow.Syallbus ? "Update -" : "Edit +"}
                        </button>
                        <div className="edit-section-title">
                          Course Syallbus
                        </div>
                        <ul>
                          {stateShow.Syallbus === false && (
                            <>
                              {formValues.syllabus &&
                                formValues.syllabus[0].name !== "" &&
                                formValues.syllabus
                                  .slice(0, numberOfSyllabus)
                                  .map((syllabus, index) => (
                                    <li key={index}>{syllabus.name}</li>
                                  ))}
                            </>
                          )}
                          {formValues?.syllabus?.length > 2 && (
                            <button
                              className="exapnd-courseHighLights"
                              onClick={handleSyllabusExpand}
                            >
                              {showMoreSyllabus ? "- Read less" : "+ Read more"}
                            </button>
                          )}
                        </ul>

                        {stateShow.Syallbus === false && (
                          <>
                            {formValues.syllabus[0].name === "" && (
                              <span
                                style={{ color: "#FF0000", fontWeight: 500 }}
                              >
                                Please fill out course syallbus
                              </span>
                            )}
                          </>
                        )}
                        {stateShow.Syallbus === true && (
                          <div className="define-add-input">
                            {formValues.syllabus.map((item, index) => (
                              <div className="form-inline" key={index}>
                                <input
                                  type="text"
                                  name="syllabus"
                                  placeholder={`Syllabus item index ${
                                    index + 1
                                  }`}
                                  value={item.name}
                                  onChange={({ target }) =>
                                    handleInputChange(
                                      index,
                                      target.name,
                                      target.value,
                                      "name"
                                    )
                                  }
                                />

                                {index > 1 ? (
                                  <img
                                    href="javascript(void);"
                                    name="syllabus"
                                    className="align-textRemove"
                                    onClick={(event) =>
                                      removeFormFields(
                                        event,
                                        index,
                                        event.target.name
                                      )
                                    }
                                    src="https://cdn.edusity.com/icons/icon-trash.svg"
                                    alt=""
                                  />
                                ) : null}
                              </div>
                            ))}
                            <div className="define-add-text">
                              <a
                                href="javascript(void);"
                                onClick={(event) =>
                                  addFormFields(
                                    event,
                                    "syllabus",
                                    50,
                                    {
                                      ...formValues,
                                      syllabus: formValues.syllabus.map(
                                        ({ name }) => ({
                                          name,
                                        })
                                      ),
                                    },
                                    errors,
                                    { name: "" },
                                    true
                                  )
                                }
                              >
                                + Add More content fields
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}

                {!bundle && (
                  <div className="editContainer">
                    <button
                      className="courseEdit-content"
                      onClick={() =>
                        setStateShow((stateShow) => ({
                          ...stateShow,
                          category: !stateShow.category,
                        }))
                      }
                    >
                      {stateShow.category ? "Edit +" : "Update -"}
                    </button>

                    <div className="edit-section-title">Course Category</div>
                    {stateShow.category === false && (
                      <>
                        <div className="courseCategory-select">
                          <Dependent
                            selectionHandler={handledependent}
                            category={formValues.category}
                            subCategory={formValues.subCategory}
                          />
                        </div>
                      </>
                    )}

                    {stateShow.category === true && (
                      <>
                        <div className="define-add-input">
                          <div className="comment-margin-b">
                            <input
                              type="text"
                              value={formValues.category}
                              disabled
                            />
                          </div>
                          <div>
                            <input
                              type="text"
                              value={formValues.subCategory}
                              disabled
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}

                <div className="editContainer">
                  <button
                    className="courseEdit-content"
                    onClick={() =>
                      setStateShow((stateShow) => ({
                        ...stateShow,
                        level: !stateShow.level,
                      }))
                    }
                  >
                    {stateShow.level ? "Edit +" : "Update -"}
                  </button>

                  <div className="edit-section-title">Course Level</div>
                  {stateShow.level === false && (
                    <>
                      <div className="courseCategory-select">
                        <select
                          disabled={stateShow.level ? true : false}
                          aria-label="Course Level"
                          defaultValue={formValues.level}
                          name="level"
                          onChange={(event) =>
                            setFormValues({
                              ...formValues,
                              [event.target.name]: event.target.value,
                            })
                          }
                        >
                          <option>Select level of this Course</option>
                          <option value="Beginner">Beginner</option>
                          <option value="Intermediate">Intermediate</option>
                          <option value="Expert">Expert</option>
                          <option value="Pro">Pro</option>
                        </select>
                      </div>
                    </>
                  )}
                  {stateShow.level === true && <>{formValues.level}</>}
                </div>

                {formValues.courseType !== "liveCourse" && (
                  <>
                    <div className="editContainer">
                      <button
                        className="courseEdit-content"
                        onClick={() =>
                          setStateShow((stateShow) => ({
                            ...stateShow,
                            language: !stateShow.language,
                          }))
                        }
                      >
                        {stateShow.language ? "Update -" : "Edit +"}
                      </button>
                      <div className="edit-section-title">Course Language</div>
                      {stateShow.language === true && (
                        <>
                          <div className="courseCategory-select">
                            <select
                              aria-label="language"
                              className="category"
                              id="Category"
                              defaultValue={formValues.language}
                              name="language"
                              onChange={(event) =>
                                setFormValues({
                                  ...formValues,
                                  [event.target.name]: event.target.value,
                                })
                              }
                            >
                              <option>choose a Language</option>
                              <option value="English">English</option>
                              <option value="Spanish">Spanish</option>
                              <option value="French">French</option>
                              <option value="Russian">Russian</option>
                              <option value="Hindi">Hindi</option>
                              <option value="Arabic">Arabic</option>
                              <option value="Portuguese">Portuguese</option>
                              <option value="Indonesian">Indonesian</option>
                              <option value=" Russian">Russian</option>
                              <option value="Japanese">Japanese</option>
                              <option value="Mandarin Chinese">
                                Mandarin Chinese
                              </option>
                            </select>
                          </div>
                        </>
                      )}

                      {stateShow.language === false && (
                        <>{formValues.language}</>
                      )}
                    </div>

                    <div className="editContainer">
                      <button
                        className="courseEdit-content"
                        onClick={() =>
                          setStateShow((stateShow) => ({
                            ...stateShow,
                            duration: !stateShow.duration,
                          }))
                        }
                      >
                        {stateShow.duration ? "Update -" : "Edit +"}
                      </button>
                      <div className="edit-section-title">Course Duration</div>
                      {stateShow.duration == true && (
                        <>
                          <div className="courseGetContent-subClass">
                            <>
                              <input
                                type="number"
                                className="hours"
                                onKeyDown={(event) => checkIfNumber(event)}
                                aria-label="duration"
                                name="duration"
                                placeholder="Please fill out Course Duration"
                                value={formValues.duration}
                                onChange={({ target }) => handle(target)}
                                disabled={stateShow.duration ? false : true}
                              />
                              <label className="hour-text">Hours</label>
                            </>
                          </div>
                          <span className="num-error-msg-show">
                            {numError !== "" && numError}
                          </span>
                        </>
                      )}

                      {stateShow.duration === false && (
                        <>
                          <>
                            {formValues.duration === "" && (
                              <span style={{ color: "#FF0000" }}>
                                Please fill out course duration
                              </span>
                            )}
                            {formValues.duration}
                          </>
                        </>
                      )}
                    </div>
                  </>
                )}

                <div className="editContainer">
                  <button
                    className="courseEdit-content"
                    onClick={() =>
                      setStateShow((stateShow) => ({
                        ...stateShow,
                        price: !stateShow.price,
                      }))
                    }
                  >
                    {stateShow?.price ? "Update -" : "Edit +"}
                  </button>

                  <div className="align-top">
                    <div className="define-page">
                      <h3 className="edit-section-title">
                        {CourseBuilderStaticData.step17.header1}
                      </h3>
                      {stateShow.price === true && (
                        <>
                          <p>{CourseBuilderStaticData.step17.subHeader1}</p>
                          {!bundle && (
                            <div className="price-section">
                              <input
                                aria-label="price selection"
                                type="checkbox"
                                checked={formValues.isFree}
                                disabled={formValues.isFree}
                                onChange={() => {
                                  setFormValues({
                                    ...formValues,
                                    isFree: !formValues.isFree,
                                    enrollmentFee: "FREE",
                                  });
                                }}
                              />
                              <p>{CourseBuilderStaticData.step17.subHeader2}</p>
                            </div>
                          )}

                          {!formValues.isFree && (
                            <div>
                              <div className="price-inner-cost">
                                <div className="define-add-input price-inner-cost-inner">
                                  <input
                                    type="text"
                                    name="enrollmentFee"
                                    id="enrollmentFee"
                                    value="USD $"
                                    readOnly
                                  />
                                </div>
                                <div className="define-add-input price-inner-cost-inner">
                                  <input
                                    type="number"
                                    placeholder="Enter your price"
                                    name="enrollmentFee"
                                    disabled={
                                      stateShow.price && stateShow.price
                                        ? false
                                        : true
                                    }
                                    id="enrollmentFee"
                                    value={
                                      formValues.enrollmentFee !== 0 &&
                                      formValues.enrollmentFee
                                    }
                                    onChange={({ target }) =>
                                      setFormValues({
                                        ...formValues,
                                        enrollmentFee: target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>

                              <h4>{CourseBuilderStaticData.step17.header2}</h4>
                              <p>
                                {CourseBuilderStaticData.step17.subHeader3}{" "}
                              </p>
                              <div className="price-inner-cost-inner">
                                <select
                                  aria-label="Category"
                                  className="category"
                                  id="Category"
                                  name="Category"
                                  disabled={
                                    stateShow.price && stateShow.price
                                      ? false
                                      : true
                                  }
                                  value={formValues.promotionalOffer}
                                  onChange={({ target }) => {
                                    setFormValues({
                                      ...formValues,
                                      promotionalOffer: target.value === "true",
                                      promotionalCode:
                                        target.value === "true"
                                          ? formValues.promotionalCode
                                          : "",
                                    });
                                  }}
                                >
                                  <option value="" hidden>
                                    Discount promo CODE
                                  </option>
                                  <option value="true">
                                    Yes, I want a code
                                  </option>
                                  <option value="false">
                                    No, I do not want a code
                                  </option>
                                </select>
                              </div>
                              {formValues.promotionalOffer ? (
                                <div className="define-add-input price-inner-cost-inner-promocode">
                                  <input
                                    type="text"
                                    placeholder="Enter your Promotional code"
                                    name="price"
                                    value={formValues.promotionalCode}
                                    disabled={
                                      stateShow.price && stateShow.price
                                        ? false
                                        : true
                                    }
                                    onChange={({ target }) =>
                                      setFormValues({
                                        ...formValues,
                                        promotionalCode: target.value,
                                      })
                                    }
                                  />
                                </div>
                              ) : null}

                              <p>
                                Want percentage discount for this course do you
                                want to offer?
                              </p>
                              <div className="define-add-input price-inner-cost-inner">
                                <input
                                  type="text"
                                  placeholder="percentage"
                                  name="percentage"
                                  value={formValues.discountPercent}
                                  onChange={({ target }) =>
                                    setFormValues({
                                      ...formValues,
                                      discountPercent: target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                    {stateShow.price === false && (
                      <>
                        {formValues.price}
                        {formValues.currency}
                        {formValues.enrollmentFee === 0
                          ? "FREE"
                          : formValues.enrollmentFee}
                      </>
                    )}
                  </div>
                </div>

                {!bundle && (
                  <>
                    {formValues?.courseSections?.length > 0 &&
                      formValues.courseSections.map(
                        (
                          {
                            name,
                            description,
                            files,
                            id,
                            courseID,
                            isEdit,
                            videoLink,
                          },

                          index
                        ) => (
                          <EditableChapter
                            title={name}
                            content={description}
                            files={files}
                            history={props.history}
                            isCurrentFileUploadStatus={
                              isCurrentFileUploadStatus
                            }
                            isCurrentFileUpload={isCurrentFileUpload}
                            videoLink={videoLink}
                            formValues={formValues}
                            setFormValues={setFormValues}
                            handleEditorStateChange={handleEditorStateChange}
                            handleInputChange={handleInputChange}
                            courseSectionId={id}
                            index={index}
                            handle={handle}
                            courseID={courseID}
                            add={isEdit}
                            fetchAll={fetchAll}
                            removeFormFields={removeFormFields}
                            courseFile={courseFile(
                              index,
                              files[0]?.courseDetailId,
                              courseID,
                              formValues
                            )}
                          />
                        )
                      )}
                  </>
                )}

                {formValues.courseType !== "liveCourse" && (
                  <>
                    {!bundle && (
                      <>
                        {formValues?.courseSections?.length < 200 && (
                          <div className="innerQuiz-button addCourse-Section">
                            <button
                              className="btn-3 create-question addNewSection"
                              disabled={isCurrentFileUpload}
                              onClick={(event) =>
                                addFormFields(
                                  event,
                                  "courseSections",
                                  200,
                                  {
                                    ...formValues,
                                    courseSections: [
                                      ...formValues.courseSections.map(
                                        ({ name, description }) => ({
                                          name,
                                          description:
                                            JSON.stringify(description),
                                        })
                                      ),
                                    ],
                                  },
                                  errors,
                                  {
                                    name: "",
                                    description: null,
                                    files: [],
                                    videoLink: "",
                                  },
                                  true
                                )
                              }
                            >
                              Add New Section +
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}

                {formValues.courseType !== "liveCourse" && (
                  <>
                    {!bundle && (
                      <div className="accordion-item-1 border-bottom-accordion">
                        <div className="accordion-title  mycoursedetails">
                          <div>Course Quiz</div>
                          <div className="expn-elte-btn">
                            <button
                              className="course-chapter-expand"
                              onClick={handleraccordion}
                            >
                              {isActive ? "Collapse" : "Expand"}
                            </button>
                          </div>
                        </div>
                        {isActive && (
                          <div className="accordion-content border-top-content">
                            <div className="">
                              <div>
                                <div className="">
                                  <Quiz
                                    setQuizCreation={setQuizCreation}
                                    quizCreation={quizCreation}
                                    setQuizValidateMsg={setQuizValidateMsg}
                                    quizValidateMsg={quizValidateMsg}
                                    updateQuizResponse={updateQuizResponse}
                                  />
                                  {!quizPop && (
                                    <>
                                      <div className="innerQuiz-button">
                                        {!quizResponse ? (
                                          quizCreation?.questions?.every(
                                            (item) =>
                                              item?.question !== null &&
                                              item?.answers?.every(
                                                (data) => data?.answer !== ""
                                              )
                                          ) ? (
                                            <button
                                              className="btn-3 create-question quizUpdate"
                                              onClick={quizSubmitHandler}
                                            >
                                              Update Quiz
                                            </button>
                                          ) : (
                                            <button
                                              className="btn-3 create-question quizUpdate-disabled"
                                              disabled
                                            >
                                              Update Quiz
                                            </button>
                                          )
                                        ) : (
                                          <Loading />
                                        )}
                                      </div>
                                    </>
                                  )}
                                  {quizPop && (
                                    <div className="quiz-eveny-0">
                                      <div
                                        className="quiz-popup"
                                        onClick={() => setQuizPop(!quizPop)}
                                      >
                                        <i className="icon check"></i>
                                      </div>
                                      <p>{updateQuizResponse}</p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {showCoursePreview && (
                          <OverlayContainer>
                            <CoursePreview
                              courseName={formValues.courseName}
                              courseImg={
                                formValues.imageFiles[0] &&
                                getS3URL(formValues.imageFiles[0].fileName)
                              }
                              courseVid={getS3URL(
                                formValues.videoFiles[0].fileName
                              )}
                              toogle={setShowCoursePreview}
                            />
                          </OverlayContainer>
                        )}
                      </div>
                    )}
                  </>
                )}

                {formValues.courseType === "liveCourse" && (
                  <div className="accordion-item-1 border-bottom-accordion">
                    <div className="accordion-title  mycoursedetails">
                      <div>Webinar Scheduler </div>
                      <div className="expn-elte-btn">
                        <button
                          className="course-chapter-expand"
                          onClick={() =>
                            setStateShow((stateShow) => ({
                              ...stateShow,
                              WebinarScheduler: !stateShow.WebinarScheduler,
                            }))
                          }
                        >
                          {stateShow.WebinarScheduler ? "Collapse" : "Expand"}
                        </button>
                      </div>
                    </div>
                    {stateShow.WebinarScheduler && (
                      <div className="editWebniar">
                        <WebinarScheduler
                          history={props}
                          schedule={setFormValues}
                          formValues={formValues}
                          current={null}
                        />
                      </div>
                    )}
                  </div>
                )}

                {bundle && (
                  <div className="editContainer">
                    <button
                      className="courseEdit-content"
                      onClick={() =>
                        setStateShow((stateShow) => ({
                          ...stateShow,
                          selectedCourse: !stateShow.selectedCourse,
                        }))
                      }
                    >
                      {stateShow.selectedCourse ? "Update -" : " Edit +"}
                    </button>

                    <div className="edit-section-title">
                      Bundle Selected Courses
                    </div>
                    <ul>
                      <div>
                        {formValues &&
                          formValues?.courses &&
                          formValues?.courses.length > 0 &&
                          formValues?.courses?.map((ele, item) => (
                            <div
                              key={item}
                              className="border-bottom-courseBundle "
                            >
                              <div
                                className="main-conatiner-course-bundle"
                                style={{ width: "100%" }}
                              >
                                <div>
                                  <h4 className="bundle-Section">
                                    {ele.CourseName}
                                  </h4>
                                  <div className="courseSelected-flex">
                                    <div>{ele.Category}</div>
                                    <p>
                                      <strong>Duration:</strong>
                                      {ele.Duration === ""
                                        ? "Duration Not found"
                                        : `${ele.Duration} hrs`}
                                    </p>
                                    <p>
                                      <strong>Language:</strong>
                                      {ele.Language}
                                    </p>
                                    <p>
                                      <strong>Subtitles:</strong>English
                                    </p>
                                  </div>
                                </div>
                                <div>
                                  <img
                                    src="https://cdn.edusity.com/icons/icon-complete-check.svg"
                                    width={"20px"}
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </ul>
                    {stateShow.selectedCourse === true && (
                      <div className="createBundleContainer-Section">
                        <CreateBundle
                          selectedCourses={formValues}
                          setselectedCourses={setFormValues}
                          editbundle={true}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>

              {stateShow.saveall && (
                <EditSubmit
                  popup={popup}
                  success={success}
                  warning={warning}
                  closeHandler={closeHandler}
                  editResponse={editResponse}
                />
              )}
            </section>
          </>
        )
      )}
    </>
  );
};
export default CourseEdit;
